module.exports = require("url-template");